module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "/dist/", n(n.s = 15);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      o = function o(e, t, n) {
    return t && a(e.prototype, t), n && a(e, n), e;
  };

  function a(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var i = f(n(4)),
      s = f(n(0)),
      l = c(n(2)),
      u = c(n(3)),
      d = c(n(23));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function f(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }

  var p = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(g, s.Component), o(g, null, [{
    key: "getDerivedStateFromProps",
    value: function value(e) {
      return {
        selected: e.isSelected,
        x: e.data.x,
        y: e.data.y
      };
    }
  }]), o(g, [{
    key: "componentDidMount",
    value: function value() {
      var e = this,
          t = i.drag().on("drag", function () {
        e.handleMouseMove(i.event);
      }).on("start", this.handleDragStart).on("end", function () {
        e.handleDragEnd(i.event);
      });
      i.select(this.nodeRef.current).on("mouseout", this.handleMouseOut).call(t);
    }
  }, {
    key: "renderShape",
    value: function value() {
      var e = this.props,
          t = e.renderNode,
          n = e.data,
          o = e.nodeTypes,
          a = e.nodeSubtypes,
          i = e.nodeKey,
          l = this.state,
          d = l.hovered,
          c = l.selected,
          f = {
        height: this.props.nodeSize || 0,
        width: this.props.nodeSize || 0
      },
          p = u.default.classNames("shape"),
          h = u.default.classNames("node", {
        selected: c,
        hovered: d
      }),
          y = u.default.classNames("subtype-shape", {
        selected: this.state.selected
      }),
          v = g.getNodeTypeXlinkHref(n, o) || "",
          m = g.getNodeSubtypeXlinkHref(n, a) || "",
          b = v ? document.querySelector("defs>" + v) : null,
          w = b ? b.getAttribute("width") : 0,
          E = b ? b.getAttribute("height") : 0,
          O = n.style,
          _ = void 0 === O ? {} : O;

      return f.width = w ? parseInt(w, 10) : f.width, f.height = E ? parseInt(E, 10) : f.height, t ? t(this.nodeRef, n, n[i], c, d) : s.createElement("g", r({
        className: p
      }, f), !!n.subtype && s.createElement("use", {
        className: y,
        x: -f.width / 2,
        y: -f.height / 2,
        width: f.width,
        fill: this.getColor(),
        height: f.height,
        xlinkHref: m
      }), s.createElement("use", {
        className: h,
        x: -f.width / 2,
        y: -f.height / 2,
        fill: this.getColor(),
        stroke: g.getShade(_.color || this.DEFAULT_COLOR, -20),
        width: f.width,
        height: f.height,
        xlinkHref: v
      }));
    }
  }, {
    key: "renderText",
    value: function value() {
      var e = this.props,
          t = e.data,
          n = e.id,
          r = e.nodeTypes,
          o = e.renderNodeText,
          a = e.isSelected,
          i = e.maxTitleChars;
      return o ? o(t, n, a) : s.createElement(d.default, {
        data: t,
        nodeTypes: r,
        isSelected: this.state.selected,
        maxTitleChars: i
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.state,
          t = e.x,
          n = e.y,
          r = e.hovered,
          o = e.selected,
          a = this.props,
          i = a.opacity,
          l = a.id,
          d = a.data,
          c = u.default.classNames("node", d.type, {
        hovered: r,
        selected: o
      });
      return s.createElement("g", {
        className: c,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        id: l,
        ref: this.nodeRef,
        opacity: i,
        transform: "translate(" + t + ", " + n + ")",
        style: {
          transform: "matrix(1, 0, 0, 1, " + t + ", " + n + ")"
        }
      }, this.renderShape(), this.renderText());
    }
  }], [{
    key: "getNodeTypeXlinkHref",
    value: function value(e, t) {
      return e.type && t[e.type] ? t[e.type].shapeId : t.emptyNode ? t.emptyNode.shapeId : null;
    }
  }, {
    key: "getNodeSubtypeXlinkHref",
    value: function value(e, t) {
      return e.subtype && t && t[e.subtype] ? t[e.subtype].shapeId : t && t.emptyNode ? t.emptyNode.shapeId : null;
    }
  }]), g);

  function g(e) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, g);

    var t = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (g.__proto__ || Object.getPrototypeOf(g)).call(this, e));

    return t.handleMouseMove = function (e) {
      var n = 1 === e.sourceEvent.buttons,
          o = e.sourceEvent.shiftKey,
          a = t.props,
          i = a.nodeSize,
          s = a.layoutEngine,
          u = a.nodeKey,
          d = a.viewWrapperElem,
          c = a.data,
          f = t.state.pointerOffset;

      if (n) {
        var p = {
          x: e.x,
          y: e.y,
          pointerOffset: f
        };

        if (t.props.centerNodeOnMove || (p.pointerOffset = f || {
          x: e.x - (c.x || 0),
          y: e.y - (c.y || 0)
        }, p.x -= p.pointerOffset.x, p.y -= p.pointerOffset.y), o) {
          t.setState({
            drawingEdge: !0
          });
          var g = l.default.calculateOffset(i, t.props.data, p, u, !0, d);
          p.x += g.xOff, p.y += g.yOff;
        } else !t.state.drawingEdge && s && r(p, s.getPositionForNode(p));

        t.setState(p), t.props.onNodeMove(p, t.props.data[u], o);
      }
    }, t.handleDragStart = function () {
      t.nodeRef.current && (t.oldSibling || (t.oldSibling = t.nodeRef.current.parentElement.nextSibling), t.nodeRef.current.parentElement.parentElement.appendChild(t.nodeRef.current.parentElement));
    }, t.handleDragEnd = function (e) {
      if (t.nodeRef.current) {
        var n = t.state,
            r = n.x,
            o = n.y,
            a = n.drawingEdge,
            i = t.props,
            s = i.data,
            l = i.nodeKey,
            u = i.onNodeSelected,
            d = i.onNodeUpdate,
            c = e.sourceEvent;
        t.setState({
          mouseDown: !1,
          drawingEdge: !1,
          pointerOffset: null
        }), t.oldSibling && t.oldSibling.parentElement && t.oldSibling.parentElement.insertBefore(t.nodeRef.current.parentElement, t.oldSibling);
        var f = c.shiftKey;
        d({
          x: r,
          y: o
        }, s[l], f || a), u(s, s[l], f || a, c);
      }
    }, t.handleMouseOver = function (e) {
      var n = !1;
      e && 1 !== e.buttons && (n = !0, t.setState({
        hovered: n
      })), t.props.onNodeMouseEnter(e, t.props.data, n);
    }, t.handleMouseOut = function (e) {
      t.setState({
        hovered: !1
      }), t.props.onNodeMouseLeave(e, t.props.data);
    }, t.DEFAULT_COLOR = "#1E90FF", t.DEFAULT_STROKE = "white", t.getColor = function () {
      var e = t.state.selected,
          n = t.props.data.style,
          r = void 0 === n ? {} : n;
      return e ? g.getShade(r.color || t.DEFAULT_COLOR, 35) : r.color || t.DEFAULT_COLOR;
    }, t.state = {
      drawingEdge: !1,
      hovered: !1,
      mouseDown: !1,
      selected: !1,
      x: e.data.x || 0,
      y: e.data.y || 0,
      pointerOffset: null
    }, t.nodeRef = s.createRef(), t;
  }

  p.defaultProps = {
    isSelected: !1,
    nodeSize: 154,
    maxTitleChars: 10,
    onNodeMouseEnter: function onNodeMouseEnter() {},
    onNodeMouseLeave: function onNodeMouseLeave() {},
    onNodeMove: function onNodeMove() {},
    onNodeSelected: function onNodeSelected() {},
    onNodeUpdate: function onNodeUpdate() {},
    centerNodeOnMove: !0
  }, p.getShade = function (e, t) {
    var n = parseInt(e.substring(1, 3), 16),
        r = parseInt(e.substring(3, 5), 16),
        o = parseInt(e.substring(5, 7), 16);
    return n = parseInt(n * (100 + t) / 100), r = (r = parseInt(r * (100 + t) / 100)) < 255 ? r : 255, o = (o = parseInt(o * (100 + t) / 100)) < 255 ? o : 255, "#" + (1 === (n = n < 255 ? n : 255).toString(16).length ? "0" + n.toString(16) : n.toString(16)) + (1 === r.toString(16).length ? "0" + r.toString(16) : r.toString(16)) + (1 === o.toString(16).length ? "0" + o.toString(16) : o.toString(16));
  }, t.default = p;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      o = function o(e, t, n) {
    return t && a(e.prototype, t), n && a(e, n), e;
  };

  function a(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var i,
      s = p(n(4)),
      l = p(n(0)),
      u = n(20),
      d = n(21),
      c = n(22),
      f = (i = n(3)) && i.__esModule ? i : {
    default: i
  };

  function p(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }

  n(1);
  var g = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(h, l.Component), o(h, null, [{
    key: "getTheta",
    value: function value(e, t) {
      var n = (t.x || 0) - (e.x || 0),
          r = (t.y || 0) - (e.y || 0);
      return Math.atan2(r, n);
    }
  }, {
    key: "lineFunction",
    value: function value(e) {
      return s.line().x(function (e) {
        return e.x;
      }).y(function (e) {
        return e.y;
      })(e);
    }
  }, {
    key: "getArrowSize",
    value: function value(e) {
      return (0 < arguments.length && void 0 !== e ? e : document).querySelector("defs>marker>.arrow").getBoundingClientRect();
    }
  }, {
    key: "getEdgePathElement",
    value: function value(e, t) {
      return (1 < arguments.length && void 0 !== t ? t : document).querySelector("#edge-" + e.source + "-" + e.target + "-container>.edge-container>.edge>.edge-path");
    }
  }, {
    key: "parsePathToXY",
    value: function value(e) {
      var t = {
        source: {
          x: 0,
          y: 0
        },
        target: {
          x: 0,
          y: 0
        }
      };

      if (e) {
        var n = e.getAttribute("d"),
            r = (n = (n = n && n.replace(/^M/, "")) && n.replace(/L/, ",")) && n.split(",") || [];
        4 === (r = r.map(function (e) {
          return parseFloat(e);
        })).length && (t.source.x = r[0], t.source.y = r[1], t.target.x = r[2], t.target.y = r[3]);
      }

      return t;
    }
  }, {
    key: "getDefaultIntersectResponse",
    value: function value() {
      return {
        xOff: 0,
        yOff: 0,
        intersect: {
          type: "none",
          point: {
            x: 0,
            y: 0
          }
        }
      };
    }
  }, {
    key: "getRotatedRectIntersect",
    value: function value(e, t, n, r, o) {
      var a = 4 < arguments.length && void 0 !== o ? o : document,
          i = h.getDefaultIntersectResponse(),
          s = h.getArrowSize(a),
          l = e.getBoundingClientRect(),
          f = e.getAttribute("width"),
          p = e.getAttribute("height"),
          g = f ? parseFloat(f) : l.width,
          y = p ? parseFloat(p) : l.height,
          v = n.x || 0,
          m = n.y || 0,
          b = t.x || 0,
          w = t.y || 0,
          E = m - y / 2,
          O = m + y / 2,
          _ = v - g / 2,
          x = v + g / 2,
          S = (0, u.shape)("line", {
        x1: b,
        y1: w,
        x2: v,
        y2: m
      }),
          k = {
        topLeft: new d.Point2D(_, E),
        bottomRight: new d.Point2D(x, O)
      },
          N = [k.topLeft, new d.Point2D(k.bottomRight.x, k.topLeft.y), k.bottomRight, new d.Point2D(k.topLeft.x, k.bottomRight.y)],
          j = k.topLeft.lerp(k.bottomRight, .5),
          T = e.getAttribute("transform"),
          P = T ? T.replace(/(rotate.[0-9]*.)|[^]/g, "$1") : null,
          M = 0;

      P && (P = P.replace(/^rotate\(|\)$/g, ""), M = parseFloat(P) * Math.PI / 180);
      var C = d.Matrix2D.rotationAt(M, j),
          R = N.map(function (e) {
        return e.transform(C);
      }),
          D = c.Intersection.intersectLinePolygon(S.params[0], S.params[1], R);

      if (0 < D.points.length) {
        var I = 0,
            A = 0,
            z = D.points[0].x,
            L = D.points[0].y;
        _ < z && z < x && m < L ? A = s.height : _ < z && z < x && L < m ? A = -s.height : I = E < L && L < O && z < v ? -s.width : s.width, i.xOff = v - z - (r ? I / 1.25 : 0), i.yOff = m - L - (r ? A / 1.25 : 0), i.intersect = D.points[0];
      }

      return i;
    }
  }, {
    key: "toRadians",
    value: function value(e) {
      return e * (Math.PI / 180);
    }
  }, {
    key: "getLoopPath",
    value: function value(e, t, n) {
      var r = n + 1;
      return "M" + (e.x + 28 * Math.cos(h.toRadians(0))) + " " + (e.y + 28 * Math.sin(h.toRadians(0))) + "Q" + (e.x + 28 * Math.sin(h.toRadians(60)) + 60 * r * Math.sin(h.toRadians(60))) + " " + (e.y + 28 * Math.sin(h.toRadians(60)) + 60 * r * Math.sin(h.toRadians(60))) + " " + (e.x + 28 * Math.cos(h.toRadians(120))) + " " + (e.y + 28 * Math.sin(h.toRadians(120)));
    }
  }, {
    key: "getPathIntersect",
    value: function value(e, t, n, r, o) {
      var a = !(3 < arguments.length && void 0 !== r) || r,
          i = 4 < arguments.length && void 0 !== o ? o : document,
          s = h.getDefaultIntersectResponse(),
          l = h.getArrowSize(i),
          d = e.getBoundingClientRect(),
          c = d.width,
          f = d.height,
          p = n.x || 0,
          g = n.y || 0,
          y = t.x || 0,
          v = t.y || 0,
          m = g - f / 2,
          b = g + f / 2,
          w = p - c / 2,
          E = p + c / 2,
          O = e.getAttribute("d");

      if (/^M/.test(O)) {
        var _ = (O = O.replace(/^M /, "")).split(/[ ,]+/);

        _ = _.map(function (e, t) {
          var n = !1;
          return /Z$/.test(e) && (e = e.replace(/Z$/, ""), n = !0), t % 2 == 0 ? parseFloat(e) + w + (n ? "Z" : "") : parseFloat(e) + m + (n ? "Z" : "");
        });
        var x = (0, u.intersect)((0, u.shape)("path", {
          d: "M " + _.join(" ")
        }), (0, u.shape)("line", {
          x1: y,
          y1: v,
          x2: p,
          y2: g
        }));

        if (0 < x.points.length) {
          var S = 0,
              k = 0,
              N = x.points[0].x,
              j = x.points[0].y,
              T = 1;

          if (w < N && N < E) {
            var P = j - g;
            T = j < g ? -1 : 1, k = l.height * T, k *= Math.min(Math.abs(P), 1);
          }

          if (m < j && j < b) {
            var M = N - p;
            T = N < p ? -1 : 1, S = l.width * T, S *= Math.min(Math.abs(M), 1);
          }

          s.xOff = p - N - (a ? S / 1.25 : 0), s.yOff = g - j - (a ? k / 1.25 : 0), s.intersect = x.points[0];
        }

        return s;
      }
    }
  }, {
    key: "getCircleIntersect",
    value: function value(e, t, n, r, o) {
      var a = !(3 < arguments.length && void 0 !== r) || r,
          i = 4 < arguments.length && void 0 !== o ? o : document,
          s = h.getDefaultIntersectResponse(),
          l = h.getArrowSize(i),
          d = l.width,
          c = l.height,
          f = e.getBoundingClientRect(),
          p = e.parentElement,
          g = p.getAttribute("width"),
          y = p.getAttribute("width");
      g = g && parseFloat(g), y = y && parseFloat(y);

      var v = g || f.width,
          m = y || f.height,
          b = n.x || 0,
          w = n.y || 0,
          E = t.x || 0,
          O = t.y || 0,
          _ = v / 2 + (a ? d / 1.25 : 0),
          x = m / 2 + (a ? c / 1.25 : 0),
          S = (0, u.intersect)((0, u.shape)("ellipse", {
        rx: _,
        ry: x,
        cx: b,
        cy: w
      }), (0, u.shape)("line", {
        x1: E,
        y1: O,
        x2: b,
        y2: w
      }));

      if (0 < S.points.length) {
        var k = S.points[0].x,
            N = S.points[0].y;
        s.xOff = b - k, s.yOff = w - N, s.intersect = S.points[0];
      }

      return s;
    }
  }, {
    key: "calculateOffset",
    value: function value(e, t, n, o, a, i) {
      var s = !(4 < arguments.length && void 0 !== a) || a,
          l = 5 < arguments.length && void 0 !== i ? i : document,
          u = h.getDefaultIntersectResponse();
      if (!n[o]) return u;
      var d = document.getElementById("node-" + n[o]);
      if (!d) return u;
      var c = d.querySelector("use.node");
      if (!c || c && !c.getAttributeNS) return u;
      var f = c.getAttributeNS("http://www.w3.org/1999/xlink", "href");
      if (!f) return u;
      var p = l.querySelector("defs>" + f + " rect:not([data-intersect-ignore=true])"),
          g = p ? null : l.querySelector("defs>" + f + " path:not([data-intersect-ignore=true])"),
          y = g || g ? null : l.querySelector("defs>" + f + " circle:not([data-intersect-ignore=true]), defs>" + f + " ellipse:not([data-intersect-ignore=true]), defs>" + f + " polygon:not([data-intersect-ignore=true])");
      return r({}, u, p ? h.getRotatedRectIntersect(p, t, n, s, l) : g ? h.getPathIntersect(g, t, n, s, l) : h.getCircleIntersect(y, t, n, s, l));
    }
  }, {
    key: "getXlinkHref",
    value: function value(e, t) {
      return t.type && e[t.type] ? e[t.type].shapeId : e.emptyEdge ? e.emptyEdge.shapeId : null;
    }
  }]), o(h, [{
    key: "getPathDescription",
    value: function value() {
      var e = this.props,
          t = e.sourceNode,
          n = e.targetNode,
          r = e.nodeKey,
          o = e.nodeSize,
          a = e.viewWrapperElem,
          i = e.n,
          s = e.i,
          l = h.calculateOffset(o || 0, n, t, r, !1, a),
          u = h.calculateOffset(o || 0, t, n, r, !0, a);
      return n === t ? h.getLoopPath(t, i, s, l) : h.getArcPath(t, n, l, u, i, s);
    }
  }, {
    key: "renderLabelText",
    value: function value(e) {
      var t = this.props.labelStyle,
          n = void 0 === t ? {} : t,
          o = function (e, t) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return function (e, t) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, s = e[Symbol.iterator](); !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, a = e;
          } finally {
            try {
              !r && s.return && s.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }(this.getEdgeHandleRotation(), 1)[0];

      return l.createElement("text", {
        className: "edge-text",
        textAnchor: "middle",
        alignmentBaseline: "central",
        style: r({}, n),
        transform: this.getEdgeHandleTranslation() + " " + o + " translate(0,0)"
      }, e.label);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.data,
          n = e.edgeTypes,
          r = e.edgeHandleSize;
      if (!e.viewWrapperElem) return null;
      var o = (t.source || "") + "_" + t.target,
          a = f.default.classNames("edge", {
        selected: this.props.isSelected
      }),
          i = this.getEdgeHandleTransformation();
      return l.createElement("g", {
        className: "edge-container",
        "data-source": t.source,
        "data-target": t.target,
        "data-id": t.id
      }, l.createElement("g", {
        className: a
      }, l.createElement("path", {
        className: "edge-path",
        fill: "none",
        d: this.getPathDescription() || void 0
      }), l.createElement("use", {
        xlinkHref: h.getXlinkHref(n, t),
        width: r,
        height: r,
        style: {
          transform: i
        }
      }), this.renderLabelText(t)), l.createElement("g", {
        className: "edge-mouse-handler"
      }, l.createElement("title", null, t.handleTooltipText), l.createElement("path", {
        fill: "none",
        className: "edge-overlay-path",
        ref: this.edgeOverlayRef,
        id: o,
        "data-source": t.source,
        "data-id": t.id,
        "data-target": t.target,
        d: this.getPathDescription() || void 0
      })));
    }
  }]), h);

  function h(e) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, h);

    var t = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (h.__proto__ || Object.getPrototypeOf(h)).call(this, e));

    return t.getEdgeHandleTranslation = function () {
      var e = t.getPathDescription();

      if (!(e = e.replace(/^M/, "")).includes("Q")) {
        var n = e.split(" ");
        return "translate(" + (parseFloat(n[0]) + parseFloat(n[2])) / 2 + ", " + (parseFloat(n[1]) + parseFloat(n[3])) / 2 + ")";
      }

      var r = (e = e.replace(/Q/, " ")).split(" "),
          o = r[0],
          a = r[1],
          i = r[2],
          s = r[3];
      return "translate(" + (.25 * o + .5 * i + .25 * r[4]) + ", " + (.25 * a + .5 * s + .25 * r[5]) + ")";
    }, t.getEdgeHandleOffsetTranslation = function () {
      var e = -(t.props.edgeHandleSize || 0) / 2;
      return "translate(" + e + ", " + e + ")";
    }, t.getEdgeHandleRotation = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0],
          n = !1,
          r = t.props.sourceNode,
          o = t.props.targetNode,
          a = 180 * h.getTheta(r, o) / Math.PI;
      return e && (a = -a), (90 < a || a < -90) && (a += 180, n = !0), ["rotate(" + a + ")", n, a];
    }, t.getEdgeHandleTransformation = function () {
      return t.getEdgeHandleTranslation() + " " + (t.props.rotateEdgeHandle ? t.getEdgeHandleRotation()[0] : "") + " " + t.getEdgeHandleOffsetTranslation();
    }, t.edgeOverlayRef = l.createRef(), t;
  }

  g.ARC_N = 10, g.ARC_K = 40, g.defaultProps = {
    edgeHandleSize: 50,
    isSelected: !1,
    rotateEdgeHandle: !0
  }, g.getArcPath = function (e, t, n, r, o, a) {
    var i = e.x - n.xOff,
        s = e.y - n.yOff,
        l = t.x - r.xOff,
        u = t.y - r.yOff,
        d = t.id ? g.ARC_K : 0,
        c = (i + l) / 2,
        f = (s + u) / 2,
        p = (l - i) / 2,
        h = (u - s) / 2,
        y = Math.sqrt(p * p + h * h);
    return a === (o - 1) / 2 || a === o ? "M" + i + " " + s + " " + l + " " + u : "M" + i + " " + s + "Q" + (c + h / y * d * (a - (o - 1) / 2)) + " " + (f - p / y * d * (a - (o - 1) / 2)) + " " + l + " " + u;
  }, t.default = g;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  n(2), n(1);
  var a,
      i = (a = n(24)) && a.__esModule ? a : {
    default: a
  },
      s = (function (e, t, n) {
    t && o(e.prototype, t), n && o(e, n);
  }(l, null, [{
    key: "getNodesMap",
    value: function value(e, t) {
      for (var n = {}, r = Object.keys(e).map(function (t) {
        return e[t];
      }), o = null, a = 0; a < r.length; a++) {
        n["key-" + (o = r[a])[t]] = {
          children: [],
          incomingEdges: [],
          node: o,
          originalArrIndex: a,
          outgoingEdges: [],
          parents: []
        };
      }

      return n;
    }
  }, {
    key: "countEdges",
    value: function value(e, t, n) {
      var r = !(2 < arguments.length && void 0 !== n) || n,
          o = t.source + "_" + t.target + "_",
          a = t.target + "_" + t.source + "_";
      return Object.keys(e).reduce(function (e, t) {
        return t.includes(o) || r && t.includes(a) ? e + 1 : e;
      }, 0);
    }
  }, {
    key: "getEdgesMap",
    value: function value(e) {
      for (var t = {}, n = null, r = 0; r < e.length; r++) {
        if ((n = e[r]).target) {
          var o = Math.max(0, this.countEdges(t, n, !1));
          t[(n.source || "") + "_" + n.target + "_" + n.id] = {
            edge: n,
            originalArrIndex: r,
            edgeIndex: o
          };
        }
      }

      return t;
    }
  }, {
    key: "linkNodesAndEdges",
    value: function value(e, t) {
      for (var n = null, r = null, o = null, a = 0; a < t.length; a++) {
        (o = t[a]).target && (n = e["key-" + (o.source || "")], r = e["key-" + o.target], n && r && (n.outgoingEdges.push(o), r.incomingEdges.push(o), n.children.push(r), r.parents.push(n)));
      }
    }
  }, {
    key: "removeElementFromDom",
    value: function value(e) {
      var t = document.getElementById(e);
      return !(!t || !t.parentNode || (t.parentNode.removeChild(t), 0));
    }
  }, {
    key: "findParent",
    value: function value(e, t) {
      return e && e.matches && e.matches(t) ? e : e && e.parentNode ? l.findParent(e.parentNode, t) : null;
    }
  }, {
    key: "classNames",
    value: function value() {
      for (var e = "", t = arguments.length, n = Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }

      var a = !0,
          i = !1,
          s = void 0;

      try {
        for (var l, u = function u() {
          var t = l.value;
          "string" == typeof t || "number" == typeof t ? e += " " + t : "object" !== (void 0 === t ? "undefined" : r(t)) || Array.isArray(t) || null === t ? Array.isArray(t) && (e += " " + t.join(" ")) : Object.keys(t).forEach(function (n) {
            t[n] && (e += " " + n);
          });
        }, d = n[Symbol.iterator](); !(a = (l = d.next()).done); a = !0) {
          u();
        }
      } catch (t) {
        i = !0, s = t;
      } finally {
        try {
          !a && d.return && d.return();
        } finally {
          if (i) throw s;
        }
      }

      return e.trim();
    }
  }, {
    key: "yieldingLoop",
    value: function value(e, t, n, r) {
      var o = 0;
      !function a() {
        for (var i = Math.min(o + t, e); o < i; ++o) {
          n.call(null, o);
        }

        o < e ? setTimeout(a, 0) : r && r.call(null);
      }();
    }
  }, {
    key: "hasNodeShallowChanged",
    value: function value(e, t) {
      return !this.isEqual(e, t);
    }
  }, {
    key: "isEqual",
    value: function value(e, t) {
      return (0, i.default)(e, t);
    }
  }]), l);

  function l() {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l);
  }

  t.default = s;
}, function (e, t) {
  e.exports = require("d3");
}, function (e, t, n) {
  var r = n(6);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  n(8)(r, {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  }), r.locals && (e.exports = r.locals);
}, function (e, t, n) {
  (e.exports = n(7)(!1)).push([e.i, ".view-wrapper{height:100%;width:100%;margin:0;display:flex;box-shadow:none;background:#2c353c;transition:opacity 0.167s;opacity:1;outline:none;user-select:none}.view-wrapper>.graph{align-content:stretch;flex:1;width:100%;height:100%}.view-wrapper .node .shape>use.node{color:#1e90ff;filter:url(#dropshadow);stroke-width:3px;cursor:pointer;user-select:none}.view-wrapper .node .node-text{fill:white;cursor:pointer;user-select:none}.view-wrapper .node .node-text.selected{fill:#fff}.view-wrapper .edge{color:#fff;stroke:#c1c1c1;stroke-width:2px;marker-end:url(#end-arrow);cursor:pointer}.view-wrapper .edge .edge-text{fill:#fff;filter:drop-shadow(0px 2px 2px rgba(0,0,0,0.8));stroke:none;cursor:pointer;user-select:none}.view-wrapper .edge.selected .edge-text{font-weight:bold}.view-wrapper .edge-mouse-handler{stroke:black;opacity:0;color:transparent;stroke-width:15px;cursor:pointer;pointer-events:stroke}.view-wrapper .arrow{fill:#c1c1c1}.view-wrapper .graph-controls{position:absolute;bottom:30px;left:15px;z-index:100;display:grid;grid-template-columns:auto auto;grid-gap:15px;align-items:center;user-select:none}.view-wrapper .graph-controls>.slider-wrapper{background-color:white;color:#1e90ff;border:solid 1px lightgray;padding:6.5px;border-radius:2px}.view-wrapper .graph-controls>.slider-wrapper>span{display:inline-block;vertical-align:top;margin-top:4px}.view-wrapper .graph-controls>.slider-wrapper>.slider{position:relative;margin-left:4px;margin-right:4px;cursor:pointer}.view-wrapper .graph-controls>.slider-button{background-color:white;fill:#1e90ff;border:solid 1px lightgray;outline:none;width:31px;height:31px;border-radius:2px;cursor:pointer;margin:0}.view-wrapper .circle{fill:#30404d}\n", ""]);
}, function (e, t, n) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var n = function (e, t) {
          var n = e[1] || "",
              r = e[3];
          if (!r) return n;

          if (t && "function" == typeof btoa) {
            var o = function (e) {
              return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
            }(r),
                a = r.sources.map(function (e) {
              return "/*# sourceURL=" + r.sourceRoot + e + " */";
            });

            return [n].concat(a).concat([o]).join("\n");
          }

          return [n].join("\n");
        }(t, e);

        return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
      }).join("");
    }, t.i = function (e, n) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var r = {}, o = 0; o < this.length; o++) {
        var a = this[o][0];
        "number" == typeof a && (r[a] = !0);
      }

      for (o = 0; o < e.length; o++) {
        var i = e[o];
        "number" == typeof i[0] && r[i[0]] || (n && !i[2] ? i[2] = n : n && (i[2] = "(" + i[2] + ") and (" + n + ")"), t.push(i));
      }
    }, t;
  };
}, function (e, t, n) {
  var r,
      o,
      a,
      i = {},
      s = (r = function r() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = r.apply(this, arguments)), o;
  }),
      l = (a = {}, function (e, t) {
    if ("function" == typeof e) return e();

    if (void 0 === a[e]) {
      var n = function (e, t) {
        return t ? t.querySelector(e) : document.querySelector(e);
      }.call(this, e, t);

      if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
        n = n.contentDocument.head;
      } catch (e) {
        n = null;
      }
      a[e] = n;
    }

    return a[e];
  }),
      u = null,
      d = 0,
      c = [],
      f = n(9);

  function p(e, t) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n],
          o = i[r.id];

      if (o) {
        o.refs++;

        for (var a = 0; a < o.parts.length; a++) {
          o.parts[a](r.parts[a]);
        }

        for (; a < r.parts.length; a++) {
          o.parts.push(b(r.parts[a], t));
        }
      } else {
        var s = [];

        for (a = 0; a < r.parts.length; a++) {
          s.push(b(r.parts[a], t));
        }

        i[r.id] = {
          id: r.id,
          refs: 1,
          parts: s
        };
      }
    }
  }

  function g(e, t) {
    for (var n = [], r = {}, o = 0; o < e.length; o++) {
      var a = e[o],
          i = t.base ? a[0] + t.base : a[0],
          s = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      r[i] ? r[i].parts.push(s) : n.push(r[i] = {
        id: i,
        parts: [s]
      });
    }

    return n;
  }

  function h(e, t) {
    var n = l(e.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = c[c.length - 1];
    if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), c.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = l(e.insertAt.before, n);
      n.insertBefore(t, o);
    }
  }

  function y(e) {
    if (null !== e.parentNode) {
      e.parentNode.removeChild(e);
      var t = c.indexOf(e);
      0 <= t && c.splice(t, 1);
    }
  }

  function v(e) {
    var t = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var r = n.nc;
      r && (e.attrs.nonce = r);
    }

    return m(t, e.attrs), h(e, t), t;
  }

  function m(e, t) {
    Object.keys(t).forEach(function (n) {
      e.setAttribute(n, t[n]);
    });
  }

  function b(e, t) {
    var n, r, o, a, i, s;

    if (t.transform && e.css) {
      if (!(a = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
      e.css = a;
    }

    if (t.singleton) {
      var l = d++;
      n = u = u || v(t), r = O.bind(null, n, l, !1), o = O.bind(null, n, l, !0);
    } else o = e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (i = t, s = document.createElement("link"), void 0 === i.attrs.type && (i.attrs.type = "text/css"), i.attrs.rel = "stylesheet", m(s, i.attrs), h(i, s), r = function (e, t, n) {
      var r = n.css,
          o = n.sourceMap,
          a = void 0 === t.convertToAbsoluteUrls && o;
      (t.convertToAbsoluteUrls || a) && (r = f(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
        type: "text/css"
      }),
          s = e.href;
      e.href = URL.createObjectURL(i), s && URL.revokeObjectURL(s);
    }.bind(null, n = s, t), function () {
      y(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = v(t), r = function (e, t) {
      var n = t.css,
          r = t.media;
      if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(n));
      }
    }.bind(null, n), function () {
      y(n);
    });

    return r(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        r(e = t);
      } else o();
    };
  }

  e.exports = function (e, t) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = s()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var n = g(e, t);
    return p(n, t), function (e) {
      for (var r = [], o = 0; o < n.length; o++) {
        var a = n[o];
        (s = i[a.id]).refs--, r.push(s);
      }

      for (e && p(g(e, t), t), o = 0; o < r.length; o++) {
        var s;

        if (0 === (s = r[o]).refs) {
          for (var l = 0; l < s.parts.length; l++) {
            s.parts[l]();
          }

          delete i[s.id];
        }
      }
    };
  };

  var w,
      E = (w = [], function (e, t) {
    return w[e] = t, w.filter(Boolean).join("\n");
  });

  function O(e, t, n, r) {
    var o = n ? "" : r.css;
    if (e.styleSheet) e.styleSheet.cssText = E(t, o);else {
      var a = document.createTextNode(o),
          i = e.childNodes;
      i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
    }
  }
}, function (e, t, n) {
  "use strict";

  e.exports = function (e) {
    var t = "undefined" != typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var n = t.protocol + "//" + t.host,
        r = n + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var o,
          a = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? n + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o,
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, ((o = n(12)) && o.__esModule ? o : {
    default: o
  }).default), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, [{
    key: "calculatePosition",
    value: function value(e) {
      var t = e.x,
          n = e.y,
          r = this.graphViewProps.gridSpacing,
          o = (r = r || 10) / 2,
          a = t || 0,
          i = n || 0;

      if (t && (t - o) % r != 0) {
        var s = 1;
        (t - o) % r < o && (s = -1), a = r * Math.round(t / r) + o * s;
      }

      if (n && (n - o) % r != 0) {
        var l = 1;
        (n - o) % r < o && (l = -1), i = r * Math.round(n / r) + o * l;
      }

      return {
        x: a,
        y: i
      };
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  t.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.LayoutEngines = void 0;
  var r = s(n(18)),
      o = s(n(10)),
      a = s(n(25)),
      i = s(n(26));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.LayoutEngines = {
    None: r.default,
    SnapToGrid: o.default,
    VerticalTree: a.default,
    HorizontalTree: i.default
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  n(13), n(1);
  var o = (function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(a, [{
    key: "calculatePosition",
    value: function value(e) {
      return e;
    }
  }, {
    key: "adjustNodes",
    value: function value(e) {
      for (var t = null, n = 0; n < e.length; n++) {
        t = e[n];
        var r = this.calculatePosition({
          x: t.x || 0,
          y: t.y || 0
        });
        t.x = r.x, t.y = r.y;
      }

      return e;
    }
  }, {
    key: "getPositionForNode",
    value: function value(e) {
      return this.calculatePosition(e);
    }
  }]), a);

  function a(e) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, a), this.graphViewProps = e;
  }

  t.default = o;
}, function (e, t, n) {
  "use strict";

  n(19), n(2), n(1);
}, function (e, t) {
  e.exports = require("dagre");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.GraphView = t.BwdlTransformer = t.Node = t.GraphUtils = t.Edge = t.GraphViewFast = void 0;
  var r = n(16);
  Object.defineProperty(t, "GraphViewFast", {
    enumerable: !0,
    get: function get() {
      return u(r).default;
    }
  });
  var o = n(2);
  Object.defineProperty(t, "Edge", {
    enumerable: !0,
    get: function get() {
      return u(o).default;
    }
  });
  var a = n(3);
  Object.defineProperty(t, "GraphUtils", {
    enumerable: !0,
    get: function get() {
      return u(a).default;
    }
  });
  var i = n(1);
  Object.defineProperty(t, "Node", {
    enumerable: !0,
    get: function get() {
      return u(i).default;
    }
  });
  var s = n(36);
  Object.defineProperty(t, "BwdlTransformer", {
    enumerable: !0,
    get: function get() {
      return u(s).default;
    }
  });
  var l = u(r);

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  n(11), t.GraphView = l.default, t.default = l.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      o = function o(e, t, n) {
    return t && a(e.prototype, t), n && a(e, n), e;
  };

  function a(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var i = v(n(4)),
      s = v(n(0)),
      l = y(n(17));
  n(5);
  var u = n(11);
  n(13);
  var d = y(n(27)),
      c = y(n(28)),
      f = y(n(2)),
      p = y(n(33)),
      g = y(n(3)),
      h = y(n(1));

  function y(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function v(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }

  var m = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(b, s.Component), o(b, null, [{
    key: "getDerivedStateFromProps",
    value: function value(e, t) {
      var n = e.edges,
          r = e.nodeKey,
          o = e.nodes,
          a = g.default.getNodesMap(o, r),
          i = g.default.getEdgesMap(n);
      g.default.linkNodesAndEdges(a, n);
      var s = e.selected && a["key-" + e.selected[r]] ? a["key-" + e.selected[r]] : null,
          l = e.selected && i[e.selected.source + "_" + e.selected.target + "_" + e.selected.id] ? i[e.selected.source + "_" + e.selected.target + "_" + e.selected.id] : null;
      return 0 === t.nodes.length && e.layoutEngineType && u.LayoutEngines[e.layoutEngineType] && (o = new u.LayoutEngines[e.layoutEngineType](e).adjustNodes(o, a)), {
        componentUpToDate: !0,
        edges: n,
        edgesMap: i,
        nodes: o,
        nodesMap: a,
        readOnly: e.readOnly,
        selectedEdgeObj: {
          edge: l ? l.edge : null
        },
        selectedNodeObj: {
          nodeId: s ? e.selected[r] : null,
          node: s ? s.node : null
        },
        selectionChanged: !1
      };
    }
  }]), o(b, [{
    key: "componentDidMount",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.initialBBox,
          r = t.zoomDelay,
          o = t.minZoom,
          a = t.maxZoom;
      if (document.addEventListener("keydown", this.handleWrapperKeydown), document.addEventListener("click", this.handleDocumentClick), this.zoom = i.zoom().filter(this.zoomFilter).scaleExtent([o || 0, a || 0]).on("start", function () {
        e.handleZoomStart(i.event);
      }).on("zoom", function () {
        e.handleZoom(i.event);
      }).on("end", this.handleZoomEnd), i.select(this.viewWrapper.current).on("touchstart", this.containZoom).on("touchmove", this.containZoom).on("click", this.handleSvgClicked).select("svg").call(this.zoom), this.selectedView = i.select(this.view), n) return this.handleZoomToFitImpl(n, 0), void this.renderView();
      this.renderView(), setTimeout(function () {
        null != e.viewWrapper.current && e.handleZoomToFit();
      }, r);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      document.removeEventListener("keydown", this.handleWrapperKeydown), document.removeEventListener("click", this.handleDocumentClick);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function value(e, t) {
      return e.nodes !== this.props.nodes || e.edges !== this.props.edges || !t.componentUpToDate || e.selected !== this.props.selected || e.readOnly !== this.props.readOnly || e.layoutEngineType !== this.props.layoutEngineType || e.graphId !== this.props.graphId;
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e, t) {
      var n = this.state,
          r = n.nodesMap,
          o = n.edgesMap,
          a = n.nodes,
          i = n.selectedNodeObj,
          s = n.selectedEdgeObj,
          l = this.props,
          d = l.layoutEngineType,
          c = l.graphId;

      if (e.graphId !== c && this.handleZoomToFit(), d && u.LayoutEngines[d]) {
        this.layoutEngine = new u.LayoutEngines[d](this.props);
        var f = this.layoutEngine.adjustNodes(a, r);
        this.setState({
          nodes: f
        });
      }

      var p = e.layoutEngineType !== d;
      this.removeOldEdges(t.edges, o), this.removeOldNodes(t.nodes, t.nodesMap, r), this.addNewNodes(this.state.nodes, t.nodesMap, i, t.selectedNodeObj, p), this.addNewEdges(this.state.edges, t.edgesMap, s, t.selectedEdgeObj, p), this.setState({
        componentUpToDate: !0
      });
    }
  }, {
    key: "getNodeById",
    value: function value(e, t) {
      var n = t || this.state.nodesMap;
      return n ? n["key-" + (e || "")] : null;
    }
  }, {
    key: "getEdgeBySourceTargetAndId",
    value: function value(e, t, n) {
      return this.state.edgesMap ? this.state.edgesMap[e + "_" + t + "_" + n] : null;
    }
  }, {
    key: "deleteEdgeBySourceTargetAndId",
    value: function value(e, t, n) {
      this.state.edgesMap && this.state.edgesMap[e + "_" + t + "_" + n] && delete this.state.edgesMap[e + "_" + t + "_" + n];
    }
  }, {
    key: "addNewNodes",
    value: function value(e, t, n, r, o) {
      var a = this,
          i = 4 < arguments.length && void 0 !== o && o;

      if (!this.state.draggingEdge) {
        var s = this.props.nodeKey,
            l = null,
            u = null;
        g.default.yieldingLoop(e.length, 50, function (o) {
          l = e[o], (null == (u = a.getNodeById(l[s], t)) || g.default.isEqual(u.node, l) && (n.node === r.node || !(n.node && l[s] === n.node[s] || r.node && l[s] === r.node[s]))) && !i && u || a.asyncRenderNode(l);
        });
      }
    }
  }, {
    key: "removeOldNodes",
    value: function value(e, t, n) {
      for (var r = this, o = this.props.nodeKey, a = function a(_a) {
        var i = e[_a][o];
        if (r.getNodeById(i, n)) return "continue";
        var s = r.getNodeById(i, t);
        s && (s.outgoingEdges.forEach(function (e) {
          r.removeEdgeElement(e.source, e.target, e.id);
        }), s.incomingEdges.forEach(function (e) {
          r.removeEdgeElement(e.source, e.target, e.id);
        })), setTimeout(function () {
          g.default.removeElementFromDom("node-" + i + "-container");
        });
      }, i = 0; i < e.length; i++) {
        a(i);
      }
    }
  }, {
    key: "addNewEdges",
    value: function value(e, t, n, r, o) {
      var a = this,
          i = 4 < arguments.length && void 0 !== o && o;

      if (!this.state.draggingEdge) {
        var s = null;
        g.default.yieldingLoop(e.length, 50, function (o) {
          if ((s = e[o]).source && s.target) {
            var l = t[s.source + "_" + s.target];
            (i || !l || !g.default.isEqual(l.edge, s) || n.edge && s === n.edge || r.edge && r.edge) && a.asyncRenderEdge(s);
          }
        });
      }
    }
  }, {
    key: "removeEdgeElement",
    value: function value(e, t, n) {
      var r = e + "-" + t + "-" + n;
      g.default.removeElementFromDom("edge-" + r + "-container");
    }
  }, {
    key: "canSwap",
    value: function value(e, t, n) {
      return t && e !== t && (n.source !== e[this.props.nodeKey] || n.target !== t[this.props.nodeKey]);
    }
  }, {
    key: "deleteNode",
    value: function value(e) {
      var t = this.props.nodeKey,
          n = this.state.nodes,
          r = e[t],
          o = n.filter(function (e) {
        return e[t] !== r;
      });
      this.setState({
        componentUpToDate: !1,
        hoveredNode: !1
      }), g.default.removeElementFromDom("node-" + r + "-container"), this.props.onSelectNode(null), this.props.onDeleteNode(e, r, o);
    }
  }, {
    key: "deleteEdge",
    value: function value(e) {
      var t = this.state.edges;

      if (e.source && e.target) {
        var n = t.filter(function (t) {
          return !(t.id === e.id);
        });
        e.source && e.target && e.id && this.deleteEdgeBySourceTargetAndId(e.source, e.target, e.id), this.setState({
          componentUpToDate: !1,
          edges: n
        }), e.source && e.target && (g.default.removeElementFromDom("edge-" + e.source + "-" + e.target + "-custom-container"), g.default.removeElementFromDom("edge-" + e.source + "-" + e.target + "-container")), this.props.onDeleteEdge(e, n);
      }
    }
  }, {
    key: "isPartOfEdge",
    value: function value(e) {
      return !!g.default.findParent(e, ".edge-container");
    }
  }, {
    key: "createNewEdge",
    value: function value() {
      var e = this.props,
          t = e.canCreateEdge,
          n = e.onCreateEdge,
          r = this.state,
          o = r.edgesMap,
          a = r.edgeEndNode,
          i = r.hoveredNodeData;
      i && (g.default.removeElementFromDom("edge-custom-container"), a && (o && t && t(i, a) ? (this.setState({
        componentUpToDate: !1,
        draggedEdge: null,
        draggingEdge: !1
      }), n(i, a), this.forceUpdate()) : this.setState({
        edgeEndNode: null,
        draggingEdge: !1
      })));
    }
  }, {
    key: "isArrowClicked",
    value: function value(e) {
      var t = this.props.edgeArrowSize,
          n = i.event.sourceEvent.target,
          r = t || 0;
      if (!e || "path" !== n.tagName) return !1;
      var o = i.mouse(n);
      if (!e.target) return !1;
      var a = o[0],
          s = o[1],
          l = f.default.parsePathToXY(f.default.getEdgePathElement(e, this.viewWrapper.current));
      return a < l.target.x + r && a > l.target.x - r && s < l.target.y + r && s > l.target.y - r;
    }
  }, {
    key: "zoomFilter",
    value: function value() {
      return !i.event.button && !i.event.ctrlKey;
    }
  }, {
    key: "containZoom",
    value: function value() {
      (i.event.button || i.event.ctrlKey) && i.event.stopImmediatePropagation();
    }
  }, {
    key: "getMouseCoordinates",
    value: function value(e) {
      var t = [0, 0];
      return this.selectedView && e && (t = e(this.selectedView.node())), t;
    }
  }, {
    key: "dragEdge",
    value: function value(e, t) {
      var n = this.props,
          r = n.nodeSize,
          o = n.nodeKey;

      if (e = e || this.state.draggedEdge) {
        var a = this.getMouseCoordinates(t),
            i = {
          x: a[0],
          y: a[1]
        },
            s = f.default.calculateOffset(r, this.getNodeById(e.source).node, i, o);
        i.x += s.xOff, i.y += s.yOff, this.syncRenderEdge({
          source: e.source,
          targetPosition: i
        }), this.setState({
          draggedEdge: e,
          draggingEdge: !0
        });
      }
    }
  }, {
    key: "setZoom",
    value: function value(e, t, n, r) {
      var o = 0 < arguments.length && void 0 !== e ? e : 1,
          a = 1 < arguments.length && void 0 !== t ? t : 0,
          s = 2 < arguments.length && void 0 !== n ? n : 0,
          l = 3 < arguments.length && void 0 !== r ? r : 0,
          u = i.zoomIdentity.translate(a, s).scale(o);
      i.select(this.viewWrapper.current).select("svg").transition().duration(l).call(this.zoom.transform, u);
    }
  }, {
    key: "renderView",
    value: function value() {
      this.selectedView.attr("transform", this.state.viewTransform), clearTimeout(this.renderNodesTimeout), this.renderNodesTimeout = setTimeout(this.renderNodes);
    }
  }, {
    key: "asyncRenderNode",
    value: function value(e) {
      var t = this,
          n = this.props.nodeKey,
          r = "nodes-" + e[n];
      cancelAnimationFrame(this.nodeTimeouts[r]), this.nodeTimeouts[r] = requestAnimationFrame(function () {
        t.syncRenderNode(e);
      });
    }
  }, {
    key: "syncRenderNode",
    value: function value(e) {
      var t = this.props.nodeKey,
          n = "node-" + e[t],
          r = this.getNodeComponent(n, e),
          o = this.getNodeById(e[t]);
      this.renderNode(n, r), o && this.renderConnectedEdgesFromNode(o);
    }
  }, {
    key: "renderNode",
    value: function value(e, t) {
      if (!this.entities) return null;
      var n = e + "-container",
          r = document.getElementById(n);
      r || ((r = document.createElementNS("http://www.w3.org/2000/svg", "g")).id = n, this.entities.appendChild(r));
      var o = t;
      l.default.render(o, r);
    }
  }, {
    key: "renderConnectedEdgesFromNode",
    value: function value(e, t) {
      var n = this,
          r = 1 < arguments.length && void 0 !== t && t;
      this.state.draggingEdge || e && (e.incomingEdges.forEach(function (e) {
        n.asyncRenderEdge(e, r);
      }), e.outgoingEdges.forEach(function (e) {
        n.asyncRenderEdge(e, r);
      }));
    }
  }, {
    key: "syncRenderEdge",
    value: function value(e, t) {
      var n = 1 < arguments.length && void 0 !== t && t;

      if (e.source) {
        var r = "edge-" + (e.target ? e.source + "-" + e.target + "-" + e.id : "custom"),
            o = this.getEdgeComponent(e);
        this.renderEdge(r, o, e, n);
      }
    }
  }, {
    key: "renderGraphControls",
    value: function value() {
      var e = this.props,
          t = e.showGraphControls,
          n = e.minZoom,
          r = e.maxZoom,
          o = this.state.viewTransform;

      if (t && this.viewWrapper) {
        var a = this.viewWrapper.current.ownerDocument.getElementById("react-digraph-graph-controls-wrapper");
        a && l.default.render(s.createElement(p.default, {
          ref: this.graphControls,
          minZoom: n,
          maxZoom: r,
          zoomLevel: o ? o.k : 1,
          zoomToFit: this.handleZoomToFit,
          modifyZoom: this.modifyZoom
        }), a);
      }
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.edgeArrowSize,
          r = t.gridSpacing,
          o = t.gridDotSize,
          a = t.nodeTypes,
          i = t.nodeSubtypes,
          l = t.edgeTypes,
          u = t.renderDefs,
          f = t.gridSize,
          p = t.backgroundFillId,
          g = t.renderBackground;
      return s.createElement("div", {
        className: "view-wrapper",
        ref: this.viewWrapper
      }, s.createElement("svg", {
        className: "graph",
        ref: this.graphSvg
      }, s.createElement(c.default, {
        edgeArrowSize: n,
        gridSpacing: r,
        gridDotSize: o,
        nodeTypes: a,
        nodeSubtypes: i,
        edgeTypes: l,
        renderDefs: u
      }), s.createElement("g", {
        className: "view",
        ref: function ref(t) {
          return e.view = t;
        }
      }, s.createElement(d.default, {
        gridSize: f,
        backgroundFillId: p,
        renderBackground: g
      }), s.createElement("g", {
        className: "entities",
        ref: function ref(t) {
          return e.entities = t;
        }
      }))), s.createElement("div", {
        id: "react-digraph-graph-controls-wrapper",
        className: "graph-controls-wrapper"
      }));
    }
  }, {
    key: "panToEntity",
    value: function value(e, t) {
      var n = this.state.viewTransform,
          r = this.viewWrapper.current,
          o = e ? e.getBBox() : null,
          a = this.props.maxZoom || 2;

      if (r && o) {
        var i = r.clientWidth,
            s = r.clientHeight,
            l = {
          k: n.k,
          x: 0,
          y: 0
        },
            u = o.x + o.width / 2,
            d = o.y + o.height / 2;
        t && (l.k = .9 / Math.max(o.width / i, o.height / s), l.k > a && (l.k = a)), l.x = i / 2 - l.k * u, l.y = s / 2 - l.k * d, this.setZoom(l.k, l.x, l.y, this.props.zoomDur);
      }
    }
  }, {
    key: "panToNode",
    value: function value(e, t) {
      var n = 1 < arguments.length && void 0 !== t && t;

      if (this.entities) {
        var r = this.entities.querySelector("#node-" + e + "-container");
        this.panToEntity(r, n);
      }
    }
  }, {
    key: "panToEdge",
    value: function value(e, t, n, r) {
      var o = 3 < arguments.length && void 0 !== r && r;

      if (this.entities) {
        var a = this.entities.querySelector("#edge-" + e + "-" + t + "-" + n + "-container");
        this.panToEntity(a, o);
      }
    }
  }]), b);

  function b(e) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, b);

    var t = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this, e));

    return t.removeOldEdges = function (e, n) {
      for (var r = null, o = 0; o < e.length; o++) {
        (r = e[o]).source && r.target && n[r.source + "_" + r.target + "_" + r.id] || t.removeEdgeElement(r.source, r.target, r.id);
      }
    }, t.handleDelete = function (e) {
      var n = t.props,
          r = n.canDeleteNode,
          o = n.canDeleteEdge;
      !n.readOnly && e && (!e.source && r && r(e) ? t.deleteNode(e) : e.source && o && o(e) && t.deleteEdge(e));
    }, t.handleWrapperKeydown = function (e) {
      var n = t.props,
          r = n.selected,
          o = n.onUndo,
          a = n.onCopySelected,
          i = n.onPasteSelected,
          s = t.state,
          l = s.focused,
          u = s.selectedNodeObj;
      if (l) switch (e.key) {
        case "Delete":
        case "Backspace":
          u && t.handleDelete(u.node || r);
          break;

        case "z":
          (e.metaKey || e.ctrlKey) && o && o();
          break;

        case "c":
          (e.metaKey || e.ctrlKey) && u.node && a && a();
          break;

        case "v":
          (e.metaKey || e.ctrlKey) && u.node && i && i();
      }
    }, t.handleEdgeSelected = function (e) {
      var n = e.target.dataset,
          o = n.source,
          a = n.target,
          i = n.id,
          s = {
        svgClicked: !0,
        focused: !0
      };

      if (o && a) {
        if (!t.getEdgeBySourceTargetAndId(o, a, i)) return;
        var l = t.getEdgeBySourceTargetAndId(o, a, i).originalArrIndex;
        s = r({}, s, {
          selectedEdgeObj: {
            componentUpToDate: !1,
            edge: t.state.edges[l]
          }
        }), t.setState(s), t.props.onSelectEdge(t.state.edges[l]);
      } else t.setState(s);
    }, t.handleSvgClicked = function (e, n) {
      var r = t.props,
          o = r.onBackgroundClick,
          a = r.onSelectNode,
          s = r.readOnly,
          l = r.onCreateNode;
      if (t.isPartOfEdge(i.event.target)) t.handleEdgeSelected(i.event);else if (t.state.selectingNode) t.setState({
        focused: !0,
        selectingNode: !1,
        svgClicked: !0
      });else {
        if (!i.event.shiftKey && o && i.event.target.classList.contains("background")) {
          var u = i.mouse(i.event.target);
          o(u[0], u[1], i.event);
        }

        var d = t.state.selectedNodeObj && t.state.selectedNodeObj.node || null;

        if (t.setState({
          selectedNodeObj: null,
          focused: !0,
          svgClicked: !0
        }), a(null), d && t.syncRenderNode(d), !s && i.event.shiftKey) {
          var c = i.mouse(i.event.target);
          l(c[0], c[1], i.event);
        }
      }
    }, t.handleDocumentClick = function (e) {
      e && e.target && null != e.target.ownerSVGElement && e.target.ownerSVGElement === t.graphSvg.current || t.setState({
        documentClicked: !0,
        focused: !1,
        svgClicked: !1
      });
    }, t.handleNodeMove = function (e, n, r) {
      var o = t.props,
          a = o.canCreateEdge,
          i = o.readOnly,
          s = t.getNodeById(n);

      if (s) {
        var l = s.node;
        i || (r || t.state.draggingEdge ? (a && a(n) || t.state.draggingEdge) && (t.syncRenderEdge({
          source: n,
          targetPosition: e
        }), t.setState({
          draggingEdge: !0
        })) : (l.x = e.x, l.y = e.y, t.renderConnectedEdgesFromNode(s, !0), t.asyncRenderNode(l)));
      }
    }, t.handleNodeUpdate = function (e, n, o) {
      var a = t.props,
          i = a.onUpdateNode;

      if (!a.readOnly) {
        if (o) t.createNewEdge();else {
          var s = t.getNodeById(n);
          s && (r(s.node, e), i(s.node));
        }
        t.setState({
          componentUpToDate: !1,
          focused: !0,
          hoveredNode: !1,
          svgClicked: !0
        });
      }
    }, t.handleNodeMouseEnter = function (e, n, r) {
      r && !t.state.hoveredNode || r || !t.state.hoveredNode || !t.state.draggingEdge ? t.setState({
        hoveredNode: !0,
        hoveredNodeData: n
      }) : t.setState({
        edgeEndNode: n
      });
    }, t.handleNodeMouseLeave = function (e, n) {
      if (!(i.event && i.event.toElement && g.default.findParent(i.event.toElement, ".node") || e && e.relatedTarget && g.default.findParent(e.relatedTarget, ".node") || i.event && 1 === i.event.buttons || e && 1 === e.buttons) && e && e.relatedTarget) {
        if (e.relatedTarget.classList.contains("edge-overlay-path")) return;
        t.setState({
          hoveredNode: !1,
          edgeEndNode: null
        });
      }
    }, t.handleNodeSelected = function (e, n, r, o) {
      var a = {
        componentUpToDate: !1,
        selectedNodeObj: {
          nodeId: n,
          node: e
        }
      };
      t.setState(a), r || t.props.onSelectNode(e, o);
    }, t.handleZoomStart = function (e) {
      var n = e.sourceEvent;
      if (t.props.readOnly || !n || n && !n.buttons || n && !n.target.classList.contains("edge-overlay-path")) return !1;
      var r = n.target.id,
          o = t.state.edgesMap && t.state.edgesMap[r] ? t.state.edgesMap[r].edge : null;
      if (!t.isArrowClicked(o) || !o) return !1;
      t.removeEdgeElement(o.source, o.target, o.id), t.setState({
        draggingEdge: !0,
        draggedEdge: o
      }), t.dragEdge(o, i.mouse);
    }, t.handleZoom = function (e) {
      var n = t.state.draggingEdge,
          r = e.transform;

      if (n) {
        if (n) return t.dragEdge(void 0, i.mouse), !1;
      } else i.select(t.view).attr("transform", r), t.state.viewTransform !== r && t.setState({
        viewTransform: r,
        draggedEdge: null,
        draggingEdge: !1
      }, function () {
        t.renderGraphControls();
      });
    }, t.handleZoomEnd = function () {
      var e = t.state,
          n = e.draggingEdge,
          o = e.draggedEdge,
          a = e.edgeEndNode,
          i = t.props.nodeKey;

      if (n && o) {
        var s = r({}, t.state.draggedEdge);
        g.default.removeElementFromDom("edge-custom-container"), t.setState({
          draggedEdge: null,
          draggingEdge: !1,
          hoveredNode: !1
        }, function () {
          var e = t.getNodeById(o.source),
              n = t.getNodeById(o.target);

          if (e && n) {
            var r = e.node;
            a && !t.getEdgeBySourceTargetAndId(o.source, a[i], o.id) && t.canSwap(r, a, o) ? (s.target = a[i], t.syncRenderEdge(s), t.props.onSwapEdge(e.node, a, o)) : t.syncRenderEdge(o);
          }
        });
      } else n && !o && t.setState({
        draggingEdge: !1
      });
    }, t.handleZoomToFit = function () {
      var e = i.select(t.entities).node();

      if (e) {
        var n = e.getBBox ? e.getBBox() : null;
        n && t.handleZoomToFitImpl(n, t.props.zoomDur);
      }
    }, t.handleZoomToFitImpl = function (e) {
      var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0;

      if (t.viewWrapper.current) {
        var r = i.select(t.viewWrapper.current).node(),
            o = r.clientWidth,
            a = r.clientHeight,
            s = t.props.minZoom || 0,
            l = t.props.maxZoom || 2,
            u = {
          k: (s + l) / 2,
          x: 0,
          y: 0
        };

        if (0 < e.width && 0 < e.height) {
          var d = e.width,
              c = e.height,
              f = e.x + e.width / 2,
              p = e.y + e.height / 2;
          u.k = .9 / Math.max(d / o, c / a), u.k < s ? u.k = s : u.k > l && (u.k = l), u.x = o / 2 - u.k * f, u.y = a / 2 - u.k * p;
        }

        t.setZoom(u.k, u.x, u.y, n);
      }
    }, t.modifyZoom = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0,
          r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0,
          o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 0,
          a = i.select(t.viewWrapper.current).node(),
          s = a.clientWidth / 2,
          l = a.clientHeight / 2,
          u = t.zoom.scaleExtent(),
          d = t.state.viewTransform,
          c = {
        k: d.k,
        x: d.x,
        y: d.y
      },
          f = c.k * (1 + e);
      if ((c.k = f) < u[0] || f > u[1]) return !1;
      var p = (s - c.x) / c.k,
          g = (l - c.y) / c.k,
          h = p * c.k + c.x,
          y = g * c.k + c.y;
      return c.x += s - h + n, c.y += l - y + r, t.setZoom(c.k, c.x, c.y, o), !0;
    }, t.getNodeComponent = function (e, n) {
      var r = t.props,
          o = r.nodeTypes,
          a = r.nodeSubtypes,
          i = r.nodeSize,
          l = r.renderNode,
          u = r.renderNodeText,
          d = r.nodeKey,
          c = r.maxTitleChars;
      return s.createElement(h.default, {
        key: e,
        id: e,
        data: n,
        nodeTypes: o,
        nodeSize: i,
        nodeKey: d,
        nodeSubtypes: a,
        onNodeMouseEnter: t.handleNodeMouseEnter,
        onNodeMouseLeave: t.handleNodeMouseLeave,
        onNodeMove: t.handleNodeMove,
        onNodeUpdate: t.handleNodeUpdate,
        onNodeSelected: t.handleNodeSelected,
        renderNode: l,
        renderNodeText: u,
        isSelected: t.state.selectedNodeObj.node === n,
        layoutEngine: t.layoutEngine,
        viewWrapperElem: t.viewWrapper.current,
        centerNodeOnMove: t.props.centerNodeOnMove,
        maxTitleChars: c
      });
    }, t.renderNodes = function () {
      t.entities && t.state.nodes.forEach(function (e, n) {
        t.asyncRenderNode(e);
      });
    }, t.isEdgeSelected = function (e) {
      return !!t.state.selectedEdgeObj && !!t.state.selectedEdgeObj.edge && t.state.selectedEdgeObj.edge.source === e.source && t.state.selectedEdgeObj.edge.target === e.target && t.state.selectedEdgeObj.edge.id === e.id;
    }, t.getEdgeComponent = function (e) {
      var n = t.state.edgesMap,
          r = t.getNodeById(e.source),
          o = r ? r.node : null,
          a = t.getNodeById(e.target),
          i = a ? a.node : null,
          l = e.targetPosition,
          u = t.props,
          d = u.edgeTypes,
          c = u.edgeHandleSize,
          p = u.nodeSize,
          h = u.nodeKey,
          y = e.source + "_" + e.target + "_" + e.id,
          v = g.default.countEdges(n, e),
          m = n[y] ? n[y].edgeIndex : 0;
      return s.createElement(f.default, {
        n: v,
        i: m,
        data: e,
        edgeTypes: d,
        edgeHandleSize: c,
        nodeSize: p,
        sourceNode: o,
        targetNode: i || l,
        nodeKey: h,
        viewWrapperElem: t.viewWrapper.current,
        isSelected: t.isEdgeSelected(e),
        rotateEdgeHandle: t.props.rotateEdgeHandle
      });
    }, t.renderEdge = function (e, n, r) {
      var o = 3 < arguments.length && void 0 !== arguments[3] && arguments[3];
      if (!t.entities) return null;
      var a = e + "-container",
          i = e + "-custom-container",
          s = t.state.draggedEdge,
          u = t.props.afterRenderEdge,
          d = document.getElementById(a);
      if (o && d) d.style.display = "none", a = e + "-custom-container", d = document.getElementById(a);else if (d) {
        var c = document.getElementById(i);
        d.style.display = "", c && c.remove();
      }

      if (!d && r !== s) {
        var f = document.createElementNS("http://www.w3.org/2000/svg", "g");
        f.id = a, t.entities.appendChild(f), d = f;
      }

      return d && (l.default.render(n, d), u) ? u(e, n, r, d, t.isEdgeSelected(r)) : void 0;
    }, t.asyncRenderEdge = function (e) {
      var n = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];

      if (e.source && e.target) {
        var r = "edges-" + e.source + "-" + e.target + "-" + e.id;
        cancelAnimationFrame(t.edgeTimeouts[r]), t.edgeTimeouts[r] = requestAnimationFrame(function () {
          t.syncRenderEdge(e, n);
        });
      }
    }, t.renderEdges = function () {
      var e = t.state,
          n = e.edges,
          r = e.draggingEdge;
      if (t.entities && !r) for (var o = 0; o < n.length; o++) {
        t.asyncRenderEdge(n[o]);
      }
    }, t.nodeTimeouts = {}, t.edgeTimeouts = {}, t.renderNodesTimeout = null, t.renderEdgesTimeout = null, t.viewWrapper = s.createRef(), t.graphControls = s.createRef(), t.graphSvg = s.createRef(), e.layoutEngineType && (t.layoutEngine = new u.LayoutEngines[e.layoutEngineType](e)), t.state = {
      componentUpToDate: !1,
      draggedEdge: null,
      draggingEdge: !1,
      edgeEndNode: null,
      edges: [],
      edgesMap: {},
      hoveredNode: !1,
      hoveredNodeData: null,
      nodes: [],
      nodesMap: {},
      selectedEdgeObj: null,
      selectedNodeObj: null,
      selectingNode: !1,
      documentClicked: !1,
      svgClicked: !1,
      focused: !0
    }, t;
  }

  m.defaultProps = {
    canCreateEdge: function canCreateEdge() {
      return !0;
    },
    canDeleteEdge: function canDeleteEdge() {
      return !0;
    },
    canDeleteNode: function canDeleteNode() {
      return !0;
    },
    edgeArrowSize: 6,
    gridSpacing: 36,
    layoutEngineType: "None",
    maxZoom: 1.5,
    minZoom: .15,
    nodeSize: 154,
    readOnly: !1,
    showGraphControls: !0,
    zoomDelay: 1e3,
    zoomDur: 750,
    rotateEdgeHandle: !0,
    centerNodeOnMove: !0
  }, t.default = m;
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o,
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, ((o = n(12)) && o.__esModule ? o : {
    default: o
  }).default), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, [{
    key: "calculatePosition",
    value: function value(e) {
      return e;
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  t.default = a;
}, function (e, t, n) {}, function (e, t) {
  e.exports = require("svg-intersections");
}, function (e, t) {
  e.exports = require("kld-affine");
}, function (e, t) {
  e.exports = require("kld-intersections");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o,
      a = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      i = (o = n(3)) && o.__esModule ? o : {
    default: o
  };

  n(1);
  var s = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(l, a.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(l, [{
    key: "getTypeText",
    value: function value(e) {
      return e.typeText;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.data,
          n = e.isSelected,
          r = e.maxTitleChars,
          o = t.title,
          s = i.default.classNames("node-text", {
        selected: n
      }),
          l = this.getTypeText(t);
      return a.createElement("text", {
        className: s,
        textAnchor: "middle"
      }, o && a.createElement("tspan", {
        x: 0,
        dy: 3,
        fontSize: "10px"
      }, o.length > r - 3 ? o.substr(0, r - 3) + "..." : o), !!l && a.createElement("tspan", {
        x: 0,
        dy: 9,
        fontSize: "8px",
        opacity: "0.5"
      }, l));
    }
  }]), l);

  function l() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (l.__proto__ || Object.getPrototypeOf(l)).apply(this, arguments));
  }

  t.default = s;
}, function (e, t) {
  e.exports = require("fast-deep-equal");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(14));

  n(1);
  var a,
      i = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(s, ((a = n(10)) && a.__esModule ? a : {
    default: a
  }).default), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(s, [{
    key: "adjustNodes",
    value: function value(e, t) {
      var n = this.graphViewProps,
          r = n.nodeKey,
          a = n.nodeSize,
          i = n.nodeHeight,
          s = n.nodeWidth,
          l = n.nodeSpacingMultiplier,
          u = new o.graphlib.Graph();
      u.setGraph({}), u.setDefaultEdgeLabel(function () {
        return {};
      });
      var d = l || 1.5,
          c = (a || 1) * d,
          f = void 0,
          p = void 0;
      return i && (f = i * d), s && (p = s * d), e.forEach(function (e) {
        if (t) {
          var n = "key-" + e[r],
              o = t[n];
          0 === o.incomingEdges.length && 0 === o.outgoingEdges.length || (u.setNode(n, {
            width: p || c,
            height: f || c
          }), o.outgoingEdges.forEach(function (e) {
            u.setEdge(n, "key-" + e.target);
          }));
        }
      }), o.layout(u), u.nodes().forEach(function (e) {
        var n = t[e],
            r = u.node(e);
        n.node.x = r.x, n.node.y = r.y;
      }), e;
    }
  }]), s);

  function s() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, s), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }

  t.default = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  };

  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var a = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(14));

  n(1);
  var i,
      s = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(l, ((i = n(10)) && i.__esModule ? i : {
    default: i
  }).default), function (e, t, n) {
    t && o(e.prototype, t), n && o(e, n);
  }(l, [{
    key: "adjustNodes",
    value: function value(e, t) {
      var n = this.graphViewProps,
          o = n.nodeKey,
          i = n.nodeSize,
          s = n.nodeHeight,
          l = n.nodeWidth,
          u = n.nodeSizeOverridesAllowed,
          d = n.nodeSpacingMultiplier,
          c = n.nodeLocationOverrides,
          f = n.graphConfig,
          p = d || 1.5,
          g = (i || 1) * p,
          h = new a.graphlib.Graph(),
          y = s ? s * p : g,
          v = l ? l * p : g;
      if (h.setGraph(r({
        rankdir: "LR"
      }, f)), h.setDefaultEdgeLabel(function () {
        return {};
      }), e.forEach(function (e) {
        if (t) {
          var n = e.sizeOverrides,
              r = (n = void 0 === n ? {} : n).width,
              a = n.height,
              i = "key-" + e[o],
              s = t[i];
          0 === s.incomingEdges.length && 0 === s.outgoingEdges.length || (h.setNode(i, {
            width: u && r ? r : v,
            height: u && a ? a : y
          }), s.outgoingEdges.forEach(function (e) {
            h.setEdge(i, "key-" + e.target);
          }));
        }
      }), a.layout(h), c) for (var m in c) {
        if (c.hasOwnProperty(m)) {
          var b = "key-" + m,
              w = h.node(b),
              E = c[m];
          w && E && (w.x = E.x, w.y = E.y);
        }
      }
      return h.nodes().forEach(function (e) {
        var n = t[e],
            r = h.node(e);
        n.node.x = r.x, n.node.y = r.y;
      }), e;
    }
  }]), l);

  function l() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (l.__proto__ || Object.getPrototypeOf(l)).apply(this, arguments));
  }

  t.default = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, o.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.gridSize,
          n = e.backgroundFillId,
          r = e.renderBackground;
      return null != r ? r(t) : o.createElement("rect", {
        className: "background",
        x: -(t || 0) / 4,
        y: -(t || 0) / 4,
        width: t,
        height: t,
        fill: "url(" + (n || "") + ")"
      });
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  a.defaultProps = {
    backgroundFillId: "#grid",
    gridSize: 40960
  }, t.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function r(e, t, n) {
    return t && o(e.prototype, t), n && o(e, n), e;
  };

  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var a = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      i = u(n(29)),
      s = u(n(30)),
      l = u(n(32));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var d = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(c, a.Component), r(c, null, [{
    key: "getDerivedStateFromProps",
    value: function value(e) {
      var t = [];
      return c.processGraphConfigDefs(e.nodeTypes, t), c.processGraphConfigDefs(e.nodeSubtypes, t), c.processGraphConfigDefs(e.edgeTypes, t), {
        graphConfigDefs: t
      };
    }
  }, {
    key: "processGraphConfigDefs",
    value: function value(e, t) {
      Object.keys(e).forEach(function (n) {
        var r = e[n].shapeId ? e[n].shapeId.replace("#", "") : "graphdef";
        t.push(a.cloneElement(e[n].shape, {
          key: r + "-" + (t.length + 1)
        }));
      });
    }
  }]), r(c, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.edgeArrowSize,
          n = e.gridSpacing,
          r = e.gridDotSize;
      return a.createElement("defs", null, this.state.graphConfigDefs, a.createElement(i.default, {
        edgeArrowSize: t
      }), a.createElement(s.default, {
        gridSpacing: n,
        gridDotSize: r
      }), a.createElement(l.default, null), this.props.renderDefs && this.props.renderDefs());
    }
  }]), c);

  function c(e) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, c);

    var t = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (c.__proto__ || Object.getPrototypeOf(c)).call(this, e));

    return t.state = {
      graphConfigDefs: []
    }, t;
  }

  d.defaultProps = {
    gridDotSize: 2,
    renderDefs: function renderDefs() {
      return null;
    }
  }, t.default = d;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, o.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, [{
    key: "render",
    value: function value() {
      var e = this.props.edgeArrowSize;
      return e || 0 === e ? o.createElement("marker", {
        id: "end-arrow",
        key: "end-arrow",
        viewBox: "0 -" + e / 2 + " " + e + " " + e,
        refX: "" + e / 2,
        markerWidth: "" + e,
        markerHeight: "" + e,
        orient: "auto"
      }, o.createElement("path", {
        className: "arrow",
        d: "M0,-" + e / 2 + "L" + e + ",0L0," + e / 2
      })) : null;
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  a.defaultProps = {
    edgeArrowSize: 4
  }, t.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o,
      a = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      i = (o = n(31)) && o.__esModule ? o : {
    default: o
  },
      s = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(l, a.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(l, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.gridSpacing,
          n = e.gridDotSize;
      return a.createElement("pattern", {
        id: "grid",
        key: "grid",
        width: t,
        height: t,
        patternUnits: "userSpaceOnUse"
      }, a.createElement(i.default, {
        gridSpacing: t,
        gridDotSize: n
      }));
    }
  }]), l);

  function l() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (l.__proto__ || Object.getPrototypeOf(l)).apply(this, arguments));
  }

  t.default = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, o.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.gridSpacing,
          n = e.gridDotSize;
      return o.createElement("circle", {
        className: "circle",
        cx: (t || 0) / 2,
        cy: (t || 0) / 2,
        r: n
      });
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  a.defaultProps = {
    gridDotSize: 2,
    gridSpacing: 36
  }, t.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(0)),
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, o.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, [{
    key: "render",
    value: function value() {
      return o.createElement("filter", {
        id: "dropshadow",
        key: "dropshadow",
        height: "130%"
      }, o.createElement("feGaussianBlur", {
        in: "SourceAlpha",
        stdDeviation: "3"
      }), o.createElement("feOffset", {
        dx: "2",
        dy: "2",
        result: "offsetblur"
      }), o.createElement("feComponentTransfer", null, o.createElement("feFuncA", {
        type: "linear",
        slope: "0.1"
      })), o.createElement("feMerge", null, o.createElement("feMergeNode", null), o.createElement("feMergeNode", {
        in: "SourceGraphic"
      })));
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  t.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var o = s(n(0)),
      a = s(n(34)),
      i = s(n(35));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function l(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function u() {
    return d;
  }

  var d = (0, a.default)(i.default),
      c = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(f, o.default.Component), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(f, [{
    key: "sliderToZoom",
    value: function value(e) {
      var t = this.props,
          n = t.minZoom;
      return e * ((t.maxZoom || 0) - (n || 0)) / 100 + (n || 0);
    }
  }, {
    key: "zoomToSlider",
    value: function value(e) {
      var t = this.props,
          n = t.minZoom;
      return 100 * (e - (n || 0)) / ((t.maxZoom || 0) - (n || 0));
    }
  }, {
    key: "render",
    value: function value() {
      return o.default.createElement("div", {
        className: "graph-controls"
      }, o.default.createElement("div", {
        className: "slider-wrapper"
      }, o.default.createElement("span", null, "-"), o.default.createElement("input", {
        type: "range",
        className: "slider",
        min: this.zoomToSlider(this.props.minZoom || 0),
        max: this.zoomToSlider(this.props.maxZoom || 0),
        value: this.zoomToSlider(this.props.zoomLevel),
        onChange: this.zoom,
        step: "1"
      }), o.default.createElement("span", null, "+")), o.default.createElement("button", {
        type: "button",
        className: "slider-button",
        onMouseDown: this.props.zoomToFit
      }, o.default.createElement(u, null)));
    }
  }]), f);

  function f() {
    var e, t, n;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, f);

    for (var r = arguments.length, o = Array(r), a = 0; a < r; a++) {
      o[a] = arguments[a];
    }

    return (t = n = l(this, (e = f.__proto__ || Object.getPrototypeOf(f)).call.apply(e, [this].concat(o)))).zoom = function (e) {
      var t = n.props,
          r = t.minZoom,
          o = t.maxZoom,
          a = e.target.value,
          i = n.sliderToZoom(a),
          s = i - n.props.zoomLevel;
      i <= (o || 0) && (r || 0) <= i && n.props.modifyZoom(s);
    }, l(n, t);
  }

  c.defaultProps = {
    maxZoom: 1.5,
    minZoom: .15
  }, t.default = c;
}, function (e, t) {
  e.exports = require("html-react-parser");
}, function (e, t) {
  e.exports = require("@fortawesome/fontawesome-free/svgs/solid/expand.svg");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  n(2), n(1);
  var o,
      a = (function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(i, ((o = n(37)) && o.__esModule ? o : {
    default: o
  }).default), function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(i, null, [{
    key: "transform",
    value: function value(e) {
      if (!e.States) return {
        edges: [],
        nodes: []
      };
      var t = Object.keys(e.States),
          n = [],
          r = [];
      return t.forEach(function (t) {
        var o = e.States[t];

        if (o) {
          var a = {
            title: t,
            type: o.Type,
            x: o.x || 0,
            y: o.y || 0
          };
          t === e.StartAt ? n.unshift(a) : n.push(a), "Choice" === o.Type ? (o.Choices.forEach(function (n) {
            e.States[n.Next] && r.push({
              source: t,
              target: n.Next
            });
          }), o.Default && r.push({
            source: t,
            target: o.Default
          })) : o.Next && e.States[o.Next] && r.push({
            source: t,
            target: o.Next
          });
        }
      }), {
        edges: r,
        nodes: n
      };
    }
  }, {
    key: "revert",
    value: function value(e) {
      return e;
    }
  }]), i);

  function i() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, i), function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (i.__proto__ || Object.getPrototypeOf(i)).apply(this, arguments));
  }

  t.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  n(2), n(1);
  var o = (function (e, t, n) {
    t && r(e.prototype, t), n && r(e, n);
  }(a, null, [{
    key: "transform",
    value: function value() {
      return {
        edges: [],
        nodes: []
      };
    }
  }, {
    key: "revert",
    value: function value(e) {
      return e;
    }
  }]), a);

  function a() {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, a);
  }

  t.default = o;
}]);